import React from "react";
import { useTranslation } from "react-i18next";

import FormValidation from "./FormValidation";

function GolfNGrowForm({
  index,
  formValues,
  handleFormInput,
  isRegistrationFormValid,
  formErrors,
  isParentForm,
  setter,
}) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-6 gap-x-8 gap-y-4">
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel1")} *
        </label>
        <div className="mt-1">
          <input
            onChange={(e) => handleFormInput(e, setter, isParentForm)}
            value={
              isParentForm
                ? formValues["customer-name"]
                : formValues[`customer-name-${index}`]
            }
            placeholder={t("contactFormPlaceholder1")}
            type="text"
            name={isParentForm ? "customer-name" : `customer-name-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
          <FormValidation
            errorType={
              isParentForm
                ? formErrors["customer-name"]
                : formErrors[`customer-name-${index}`]
            }
            showError={!isRegistrationFormValid}
          />
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel2")} *
        </label>
        <div className="mt-1">
          <input
            onChange={(e) => handleFormInput(e, setter, isParentForm)}
            value={
              isParentForm
                ? formValues["customer-email"]
                : formValues[`customer-email-${index}`]
            }
            placeholder={t("contactFormPlaceholder2")}
            type="text"
            name={isParentForm ? "customer-email" : `customer-email-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
          <FormValidation
            errorType={
              isParentForm
                ? formErrors["customer-email"]
                : formErrors[`customer-email-${index}`]
            }
            showError={!isRegistrationFormValid}
          />
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel7")} {isParentForm ? "*" : ""}
        </label>
        {isParentForm ? (
          <div className="text-xs font-light text-red-500">
            {t("inputPhoneNumberExtraNote")}
          </div>
        ) : null}
        <div className="flex w-full p-2 mt-1 text-gray-900 bg-white border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
          {/* <select onChange={(e) => handleFormInput(e, setter, isParentForm)} value={formValues[`customer-phcode-${index}`]} name={`customer-phcode-${index}`} className='px-2 text-sm font-bold outline-none select-none w-fit'>
            <option value='' selected></option>
            {newCountryPhoneCodes.sort((a, b) => a.code - b.code).map(((country) => (
              <option value={country.code}>{country.code}</option>
            )))}
          </select> */}
          <span>+</span>(
          <input
            type="number"
            onChange={(e) => handleFormInput(e, setter, isParentForm)}
            value={
              isParentForm
                ? formValues["customer-phcode"]
                : formValues[`customer-phcode-${index}`]
            }
            name={isParentForm ? "customer-phcode" : `customer-phcode-${index}`}
            className="w-8 text-sm font-bold text-center outline-none select-none"
          />
          <span>)</span>
          <input
            onChange={(e) => handleFormInput(e, setter, isParentForm)}
            value={
              isParentForm
                ? formValues["phone-number"]
                : formValues[`phone-number-${index}`]
            }
            name={isParentForm ? "phone-number" : `phone-number-${index}`}
            placeholder={t("contactFormPlaceholder7")}
            type="number"
            min="0"
            className="block w-full pl-2 text-gray-900 border-0 outline-none placeholder:text-gray-400 sm:text-sm sm:leading-6"
          />
        </div>
        <FormValidation
          errorType={
            isParentForm
              ? formErrors["phone-number"]
              : formErrors[`phone-number-${index}`]
          }
          showError={!isRegistrationFormValid}
        />
      </div>
    </div>
  );
}

export default GolfNGrowForm;
